import { rootApi } from '../rootApi';
import { cleanParams } from '../utils';

export const vehicleRefundOrderApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getRefundInitialData: builder.query({
            query: ({ vehicleStockId, languageId } = {}) => ({
                url: 'v1/VehicleRefundOrder/GetInitialData',
                method: 'GET',
                params: cleanParams({ VehicleStockId: vehicleStockId, LanguageId: languageId })
            }),
            transformResponse: (res) => (res?.isSuccessful ? res.data : null)
        }),
        getRefundDraftList: builder.query({
            query: ({ languageId } = {}) => ({
                url: 'v1/VehicleRefundOrder/GetDraftList',
                method: 'GET',
                params: cleanParams({ languageId })
            }),
            transformResponse: (res) => (res?.isSuccessful && Array.isArray(res?.data) ? res.data : []),
            providesTags: ['VehicleRefundOrder']
        }),
        getRefundPendingApprovalList: builder.query({
            query: ({ languageId } = {}) => ({
                url: 'v1/VehicleRefundOrder/GetPendingApprovalList',
                method: 'GET',
                params: cleanParams({ languageId })
            }),
            transformResponse: (res) => (res?.isSuccessful && Array.isArray(res?.data) ? res.data : []),
            providesTags: ['VehicleRefundOrder']
        }),
        getRefundApprovedList: builder.query({
            query: ({ languageId } = {}) => ({
                url: 'v1/VehicleRefundOrder/GetApprovedList',
                method: 'GET',
                params: cleanParams({ languageId })
            }),
            transformResponse: (res) => (res?.isSuccessful && Array.isArray(res?.data) ? res.data : []),
            providesTags: ['VehicleRefundOrder']
        }),
        getRefundRejectedList: builder.query({
            query: ({ languageId } = {}) => ({
                url: 'v1/VehicleRefundOrder/GetRejectedList',
                method: 'GET',
                params: cleanParams({ languageId })
            }),
            transformResponse: (res) => (res?.isSuccessful && Array.isArray(res?.data) ? res.data : []),
            providesTags: ['VehicleRefundOrder']
        }),
        getRefundOrderDetail: builder.query({
            query: ({ refundOrderId, languageId } = {}) => ({
                url: 'v1/VehicleRefundOrder/GetDetail',
                method: 'GET',
                params: cleanParams({ refundOrderId, languageId })
            }),
            transformResponse: (res) => (res?.isSuccessful ? res.data : null)
        }),
        createRefundDraft: builder.mutation({
            query: (body) => ({
                url: 'v1/VehicleRefundOrder/CreateDraft',
                method: 'POST',
                body
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['VehicleRefundOrder']
        }),
        updateRefundDraft: builder.mutation({
            query: (body) => ({
                url: 'v1/VehicleRefundOrder/UpdateDraft',
                method: 'PUT',
                body
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['VehicleRefundOrder']
        }),
        submitRefundForApproval: builder.mutation({
            query: (body) => ({
                url: 'v1/VehicleRefundOrder/SubmitForApproval',
                method: 'POST',
                body
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['VehicleRefundOrder']
        }),
        processRefundApproval: builder.mutation({
            query: (body) => ({
                url: 'v1/VehicleRefundOrder/ProcessApproval',
                method: 'POST',
                body
            }),
            transformResponse: (res) => res,
            invalidatesTags: ['VehicleRefundOrder']
        })
    }),
    overrideExisting: false
});

export const {
    useGetRefundInitialDataQuery,
    useLazyGetRefundInitialDataQuery,
    useGetRefundDraftListQuery,
    useLazyGetRefundDraftListQuery,
    useGetRefundPendingApprovalListQuery,
    useLazyGetRefundPendingApprovalListQuery,
    useGetRefundApprovedListQuery,
    useLazyGetRefundApprovedListQuery,
    useGetRefundRejectedListQuery,
    useLazyGetRefundRejectedListQuery,
    useGetRefundOrderDetailQuery,
    useLazyGetRefundOrderDetailQuery,
    useCreateRefundDraftMutation,
    useUpdateRefundDraftMutation,
    useSubmitRefundForApprovalMutation,
    useProcessRefundApprovalMutation
} = vehicleRefundOrderApi;
